import {
  Scoreboard,
  ScoreboardParticipant,
  ScoreboardParticipants,
  ScoreboardScore,
  ScoreboardScores
} from '@ps/isp-web-component-library';
import type { EnrichedParticipants } from '@ps/isp-web-services-types';
import type { TennisMatch } from '@ps/web-shared-generated-graphql/sports';
import { EventTypeId } from '@ps/web-sports-enums';
import React from 'react';

import Participants from '@swf/sports/components/Event/Participants/Participants';
import { getScoreCharacterLength } from '@swf/sports/utils/getScoreCharacterLength';

interface Props {
  enrichedParticipants?: EnrichedParticipants;
  match?: TennisMatch;
  eventTypeId: EventTypeId;
  eventName?: string;
}

const TennisScoreboard = ({ enrichedParticipants, match, eventName, eventTypeId }: Props) => {
  const [participantA, participantB] = enrichedParticipants ?? [];
  const currentSet = match?.currentSet;
  const currentGame = currentSet?.currentGame;
  const currentServingParticipant = currentGame?.teamServing;

  if (!currentSet) {
    return (
      <Participants
        eventTypeId={eventTypeId}
        eventName={eventName ?? ''}
        enrichedParticipants={enrichedParticipants}
      />
    );
  }

  return (
    <Scoreboard variant="lite">
      <ScoreboardParticipants>
        <ScoreboardParticipant
          name={participantA.participant}
          hasReservedMarkerSpace
          isVisibleMarker={currentServingParticipant === participantA.type}
        />
        <ScoreboardParticipant
          name={participantB.participant}
          hasReservedMarkerSpace
          isVisibleMarker={currentServingParticipant === participantB.type}
        />
      </ScoreboardParticipants>
      <ScoreboardScores>
        <ScoreboardScore score={[match.teamAScore ?? null, match.teamBScore ?? null]} />
        <ScoreboardScore score={[currentSet.teamAScore, currentSet.teamBScore]} />
        <ScoreboardScore
          score={[currentGame?.teamAScore ?? null, currentGame?.teamBScore ?? null]}
          scoreCharacterLength={getScoreCharacterLength(EventTypeId.TENNIS, [
            currentSet.teamAScore,
            currentSet.teamBScore
          ])}
        />
      </ScoreboardScores>
    </Scoreboard>
  );
};

export default TennisScoreboard;
